import { Fragment as _Fragment, jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { _className, LL_H_C, LL_V_L } from '@nu-art/thunderstorm-frontend';
import { Tooltip_Finding_Base } from '../Tooltip_Finding_Base.js';
import { _values, exists, filterInstances, formatTimestamp, sortArray } from '@nu-art/ts-common';
import './Tooltip_Finding_Vitals.scss';
import { ICONS } from '@app/styles';
import { resolveValueDisplay } from '@app/hcs-shared';
export class Tooltip_Finding_Vitals extends Tooltip_Finding_Base {
    modalPos = { x: 0, y: 1 };
    modalOffset = { x: 0, y: 10 };
    originPosResolver = (e) => {
        const rect = e.currentTarget.getBoundingClientRect();
        return { y: rect.bottom, x: rect.left + (rect.width / 2) };
    };
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        super.deriveStateFromProps(nextProps, state);
        state.title = nextProps.title;
        state.data = nextProps.data;
        return state;
    }
    //######################### Logic #########################
    resolveVariableName = () => this.state.title;
    generateResultEntries = () => {
        const map = {};
        const varIds = this.state.data.variableIds;
        varIds.forEach((varId, i) => {
            const results = this.state.data.results[varId];
            results?.forEach(result => {
                if (!map[result.timestamp])
                    map[result.timestamp] = {
                        timestamp: result.timestamp,
                        values: Array.from({ length: varIds.length }),
                        currentEncounter: result.currentEncounter
                    };
                map[result.timestamp].values[i] = result.value;
            });
        });
        return sortArray(_values(map), i => i.timestamp, true);
    };
    _resolveTimestamp = (entry) => {
        return entry.currentEncounter ? formatTimestamp('hh:mmA', entry.timestamp) : formatTimestamp('D MMM YYYY', entry.timestamp);
    };
    resolveMeasurementUnits = () => {
        const variableId = this.state.data.variableIds[0];
        const measurementUnitId = this.state.data.metadata[variableId].measurementUnitId;
        return this.props.modules.measurementUnit.cache.unique(measurementUnitId)?.unitAsString;
    };
    //######################### Render #########################
    render_Content = () => _jsxs(_Fragment, { children: [this.render_Units(), this.render_Divider(), this.render_Abnormality(), this.render_Results()] });
    render_Results = () => {
        const entries = this.generateResultEntries();
        if (entries.length)
            return _jsx(_Fragment, { children: _jsx(LL_V_L, { className: 'vital-results', children: entries.map(this.render_Result) }) });
    };
    render_NormalRange = () => {
        const varIds = this.state.data.variableIds;
        const normalRanges = varIds.map(varId => this.state.data.metadata[varId]?.varNormal);
        if (!normalRanges.filter(i => i).length)
            return;
        const min = normalRanges.map(range => exists(range) ? range[0].toLocaleString(undefined, { maximumFractionDigits: 2 }) : '-');
        const max = normalRanges.map(range => exists(range) ? range[1].toLocaleString(undefined, { maximumFractionDigits: 2 }) : '-');
        return _jsxs(LL_H_C, { className: 'finding-tooltip__normal-range', children: [_jsx("div", { className: 'finding-tooltip__normal-range__title', children: "Normal:" }), _jsxs("div", { className: 'finding-tooltip__normal-range__value', children: [min.join('/'), " - ", max.join('/')] })] });
    };
    render_Result = (entry) => {
        const value = entry.values.map(value => exists(value) ? value : '-').join('/');
        const timestamp = this._resolveTimestamp(entry);
        const className = _className('vital-result', !entry.currentEncounter && 'prev-encounter');
        return _jsxs(LL_H_C, { className: className, children: [_jsx("div", { className: 'vital-result__value', children: value }), _jsx("div", { className: 'vital-result__timestamp', children: timestamp })] }, entry.timestamp);
    };
    render_Abnormality = () => {
        const ids = this.state.data.abnormalityValueIds;
        if (!ids?.length)
            return;
        const values = filterInstances(ids.map(id => this.props.modules.value.cache.unique(id)));
        return _jsx(LL_V_L, { className: 'abnormalities', children: values.map(val => _jsxs(LL_H_C, { className: 'abnormality', children: [_jsx(ICONS.advisor_v5_warning_exclamation_mark.component, {}), resolveValueDisplay(val)] }, val._id)) });
    };
}
//# sourceMappingURL=Tooltip_Finding_Vitals.js.map